import {
  config,
  COLORS,
  CHART_COLORS_BASED_ON_INDEX,
  chartStyles,
} from "./Config";
import { formatDateWithLocale, getDatesDiffInYears } from "./Filters";

import {
  Chart,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
} from "chart.js";

Chart.register(
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale
);

export class ChartPerformance {
  constructor(data) {
    this.elements = {
      chartContainer: document.querySelector(config.chart),
    };

    if (!data || !Object.keys(data).length) {
      this.series = {};
      return;
    }

    this.series = {
      shareclass: data.shareclass,
      ...data.benchmarks,
    };
  }

  createChart() {
    if (!this.elements.chartContainer) return;
    this.chartInstance = new Chart(
      this.elements.chartContainer,
      this.generateChartsConfig()
    );
  }

  reload() {}

  reloadChart(data) {
    const dataSeries = {
      base: data.shareclass,
      ...data.benchmarks,
    };

    const newChartConfig = this.generateChartsConfig(dataSeries);
    try {
      this.chartInstance.destroy();
    } catch (e) {
      // console.log(e);
    }
    this.chartInstance = new Chart(
      this.elements.chartContainer,
      newChartConfig
    );
  }

  generateChartsConfig(dataSeries = this.series) {
    const seriesArray = Object.keys(dataSeries).map(
      (seriesNameKey) => dataSeries[seriesNameKey]
    );

    if (!seriesArray.length) {
      return {};
    }

    const datasetConfigArr = seriesArray.map((seriesElement, index) => ({
      label: seriesElement.label,
      borderColor:
        seriesElement.color ||
        CHART_COLORS_BASED_ON_INDEX[index] ||
        COLORS.COLOR_1,
      data: [...seriesElement.data].map((entry) => entry[1]),
    }));

    const startDate = new Date(seriesArray[0].data[0][0]);
    const endDate = new Date(
      seriesArray[0].data[seriesArray[0].data.length - 1][0]
    );

    const yearsDiff = getDatesDiffInYears(endDate, startDate);

    const data = {
      labels: seriesArray[0].data.map((rawEntry) => {
        const date = new Date(rawEntry[0]);

        if (yearsDiff >= 3) {
          return formatDateWithLocale(date, "Y");
        }

        if (yearsDiff >= 1 && yearsDiff < 3) {
          return formatDateWithLocale(date, "MMM Y");
        }

        return formatDateWithLocale(date, "d MMM");
      }),
      datasets: datasetConfigArr,
    };

    return {
      type: "line",
      data,
      ...chartStyles,
    };
  }
}
